import BookFreeClassButton from '@components/common/book-free-class-btn'
import { FastlyImage } from '@components/common/image'
import Modal from '@components/common/modal'
import { Trans } from '@lingui/macro'
import { ReactNode, useState } from 'react'
import { SizeType } from '@components/atoms/button'

const IMAGE_PATH = '/images/home/codingal-demo'

const DEFAULT_POINTS: ReactNode[] = [
  <Trans key="1">
    1:1 live AI & coding classes for kids and teens with expert teachers
  </Trans>,
  <Trans key="2">Project-based learning that makes every concept stick</Trans>,
  <Trans key="3">Personalized guidance at your child&apos;s pace</Trans>,
  <Trans key="4">Fun, interactive classes that build confidence</Trans>,
  <Trans key="5">Future-ready skills for a fast-changing world</Trans>,
  <Trans key="6">A trusted platform loved by parents worldwide</Trans>,
]

type Props = {
  shouldScrollToTop?: boolean
  urlQuery?: string
  ctaSize?: SizeType
  points?: ReactNode[]
  bgClassName?: string
}
const LearningDashboard = ({
  shouldScrollToTop,
  urlQuery,
  ctaSize = 'xl',
  points = DEFAULT_POINTS,
  bgClassName = 'bg-yellow-100 bg-opacity-50',
}: Props) => {
  const [ismodalOpen, setModalOpen] = useState(false)

  return (
    <div className={bgClassName}>
      <Modal
        isOpen={ismodalOpen}
        setIsOpen={setModalOpen}
        isCrossIconShown={true}
        shouldCloseOnEsc
        width="mt-12 sm:mt-5"
        className="bg-black pl-0 pr-0"
      >
        <div>
          <iframe
            src="https://iframe.mediadelivery.net/embed/239253/5cc75e56-1238-431d-9c92-8a6990efb997?autoplay=true&loop=true&muted=false&preload=false&responsive=true"
            className="-my-5 sm:-my-10 rounded-lg w-full h-80 sm:h-screen"
            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
            allowFullScreen
          ></iframe>
        </div>
      </Modal>
      <div className="container mx-auto flex lg:flex-row flex-col items-center lg:space-x-16 leading-tight py-12 lg:py-16 text-grey px-5">
        <div
          className="mb-5 lg:mb-0 cursor-pointer"
          onClick={() => setModalOpen(true)}
        >
          <FastlyImage
            src={`${IMAGE_PATH}.png`}
            webpSrc={`${IMAGE_PATH}.webp`}
            height={308}
            width={544}
            className="hover:shadow-md"
            alt="Codingal Dashboard"
          />
        </div>
        <div className="w-full">
          <h2 className="text-2xl lg:text-4xl font-600">
            <Trans>Discover what learning at Codingal looks like</Trans>
          </h2>

          <ul className="mx-0 pl-5 my-10 flex flex-col space-y-2 text-lg">
            {points.map((point, index) => (
              <li key={index}>{point}</li>
            ))}
          </ul>

          <BookFreeClassButton
            size={ctaSize}
            shouldScrollToTop={shouldScrollToTop}
            query={urlQuery}
          />
        </div>
      </div>
    </div>
  )
}

export default LearningDashboard
